import { render, staticRenderFns } from "./LocationContacts.vue?vue&type=template&id=0ed1dc46&"
import script from "./LocationContacts.vue?vue&type=script&lang=js&"
export * from "./LocationContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports